var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OpenApplet"},[_c('wx-open-launch-weapp',{attrs:{"id":"launch-btn","appid":"wxece3a9a4c82f58c9","path":"commercialize/pages/taoke-guide/index?scene=06e274c028c54179b108c0e1926d3e00"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }